import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Routes, Route, useLocation } from "react-router";
import { CardHistory } from "./CardHistory";
import { CardDetails } from "./CardDetails";
import { ManagePerson } from "./ManagePerson";
import { PrintCard } from "./PrintCard";
import { SearchCardForm } from "./SearchCardForm";
import { SearchCardSubMenu } from "./SearchCardSubMenu";
import { ManageTransactions } from "./ManageTransactions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AddTransaction } from "./AddTransaction";
import { HistoryCard } from "./HistoryCard";
import { RegisterCard } from "./RegisterCard";
import { headingSize } from "../../util/constants";
import { RESET_PERSON_NAME } from "../../redux/reducers/personReducer";
import { GET_AVAILABLE_CARD_TYPES } from "../../redux/reducers/cardTypeReducer";
import { Messages } from "../help/Messages";
import { RESET_INFO_MESSAGES } from "../../redux/reducers/messageReducer";
import { SET_SELECTED_MENU_ITEM } from "../../redux/reducers/loginReducer";

export function SearchCard() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const isHistory = location.pathname.includes("history");
  const cardWithHistory = useSelector(
    (store: any) => store.card.cardWithHistory
  );

  const carePrincipalId = useSelector(
    (state: any) => state.session.selectedCarePrincipal?.id
  );

  useEffect(() => {
    if (carePrincipalId) {
      dispatch({ type: GET_AVAILABLE_CARD_TYPES, carePrincipalId });
    }
    dispatch({ type: RESET_PERSON_NAME });
    dispatch({ type: RESET_INFO_MESSAGES });
  }, [dispatch, carePrincipalId]);

  const menuItem = t("titles.searchCard");

  useEffect(() => {
    dispatch({ type: SET_SELECTED_MENU_ITEM, menuItem });
  }, [dispatch, menuItem]);

  return (
    <Box minHeight="50vh" component="main">
      <Typography sx={{ marginBottom: "1vh" }} variant={headingSize}>
        {t("titles.searchCard")}
      </Typography>
      <Messages />
      <SearchCardForm />
      {cardWithHistory ? (
        <Box>
          {cardWithHistory.current && !isHistory ? (
            <Box>
              <Stack direction="row">
                <CardDetails
                  cardSystemId={cardWithHistory.current.cardSystemId}
                />
                {!isHistory && cardWithHistory.history[0] && (
                  <Box sx={{ marginLeft: "35vh" }}>
                    <CardHistory />
                  </Box>
                )}
              </Stack>
              <Routes>
                <Route path="manage-person" element={<ManagePerson />} />
                <Route path="manage-transactions" element={<ManageTransactions />} />
                <Route path="create-card" element={<RegisterCard />} />
                <Route path="print" element={<PrintCard />} />
                <Route path="manage-transactions/add-transaction" element={<AddTransaction />} />
              </Routes>
            </Box>
          ) : isHistory && cardWithHistory.history[0] ? (
            <Routes>
              <Route path="history/:id" element={<HistoryCard />} />
            </Routes>
          ) : (
            <>
              <Box>
                <Typography>{t("searchCard.cardInfo.noCard")}</Typography>
                <Routes>
                  <Route path="manage-person" element={<ManagePerson />} />
                  <Route path="create-card" element={<RegisterCard />} />
                  <Route path="register-card" element={<RegisterCard />} />
                  <Route path="manage-transactions/add-transaction" element={<AddTransaction />} />
                </Routes>
                {!isHistory && cardWithHistory.history[0] && (
                  <Box sx={{ marginLeft: "35vh" }}>
                    <CardHistory />
                  </Box>
                )}
              </Box>
            </>
          )}
        </Box>
      ) : null}
      {cardWithHistory &&
        cardWithHistory.history[0] &&
        !cardWithHistory.current && (
          <Box>
            <Routes>
              <Route
                path="manage-transactions/add-transaction" element={<AddTransaction />} />
              {/* <Route
                path="register-card"
                component={RegisterCard}
              /> */}
            </Routes>
          </Box>
        )}
      {cardWithHistory && <SearchCardSubMenu />}
    </Box>
  );
}
